module.exports = __webpack_public_path__ + "img/sxwd.4f5a7a3b.svg";